import axios from 'axios'
import moment from 'moment'
import { crossAnalysisTypes, formatQsca, qscaDataTypes } from '../../../modules/analysis'
import { setFilterValues, setFormValues, toggleFilterValues } from '../../../modules/mutations'
import { basicDateFormat } from '../../../modules/date'
import { castAttributesForCamelCase } from '../../../modules/string_converter'

export const companiesAnalysisQscas = {
  namespaced: true,
  state: {
    data: [],
    selectedPeriod: 12,
    selectedYear: moment().year(),
    selectedMonth: moment().month(),
    pageType: crossAnalysisTypes[2],            // 分析軸
    crossSearchField: null,                     // クロス分析軸
    individualAnalysisField: null,
    formValues: {},
    providedAiReviewSentencesAnalysis: false,
  },
  getters: {
    startTime(state,getters) {
      const endDate = moment(getters.endTime, 'YYYY/MM/DD')
      endDate.subtract(state.selectedPeriod - 1, 'months')
      return endDate.startOf('months').format('YYYY/MM/DD')
    },
    endTime(state) {
      const strMonth = state.selectedMonth + 1
      const month = strMonth < 10 ? '0' + String(strMonth) : String(strMonth)
      const date = moment(state.selectedYear + '/' + month + '/' + '01', 'YYYY/MM/DD').endOf('months')
      return basicDateFormat(date, 'YYYY/MM/DD')
    },
    loading(state) {
      return state.data.length === 0
    },
    /**
     * クロス分析の項目一覧
     * @param { Object } state
     * @returns { Array }
     */
    crossSearchFields(state) {
      const arr = [state.pageType]
      if (state.crossSearchField) {
        arr.push(state.crossSearchField)
      }
      return arr
    },
    /**
     *
     * @return {[{dataType: string, name: *, id: string, text: *}, {dataType: string, name: *, id: string, text: *}, {dataType: string, name: *, id: string, text: *}, {dataType: string, name: *, id: string, text: *}]}
     */
    dataTypes: () => qscaDataTypes,
  },
  mutations: {
    initAnalysisQscas(state) {
      state.data = []
    },
    readAnalysisQscasSuccess(state, payload) {
      state.data = payload.data.map(v => {
        return formatQsca(castAttributesForCamelCase(v))
      })
      state.meta = payload.meta
    },
    setSelectedYear(state, payload) {
      state.selectedYear = payload
    },
    setSelectedMonth(state, payload) {
      state.selectedMonth = Number(payload)
    },
    setSelectedPeriod(state, payload) {
      state.selectedPeriod = payload
    },
    setPageType(state, payload) {
      state.pageType = payload
    },
    setCrossSearchField(state, payload) {
      state.crossSearchField = payload
    },
    setIndividualAnalysisField(state, payload) {
      state.individualAnalysisField = payload
    },
    setProvidedAiReviewSentencesAnalysis(state, payload) {
      state.providedAiReviewSentencesAnalysis = payload
    },
    apiFailure(state) {
      state.loading = false
    },
    setFormValues,
    setFilterValues,
    toggleFilterValues,
  },
  actions: {
    setCrossSearchField({ commit }, val) {
      commit('setCrossSearchField', val)
    },
    setIndividualAnalysisField({ commit }, val) {
      commit('setIndividualAnalysisField', val)
    },
    setProvidedAiReviewSentencesAnalysis({ commit }, val) {
      commit('setProvidedAiReviewSentencesAnalysis', val)
    },
    setFormValues({ commit }, val) {
      commit('setFormValues', val)
    },
    setPageType({ commit }, val) {
      commit('setPageType', val)
    },
    setSelectedYear({ commit }, val) {
      commit('setSelectedYear', val)
    },
    setSelectedMonth({ commit }, val) {
      commit('setSelectedMonth', val)
    },
    setSelectedPeriod({ commit }, val) {
      commit('setSelectedPeriod', val)
    },
    initAnalysisQscas({ commit }) {
      commit('initAnalysisQscas')
    },
    readAnalysisQscas({ commit, rootState }, query) {
      commit('initAnalysisQscas')
      return axios
        .post('/api/companies/' + rootState.route.params.company_uuid + '/analysis/qscas' + '.json', query)
        .then(res => {
          commit('readAnalysisQscasSuccess', res.data)
        })
        .catch(err => {
          console.error(err)
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
  }
}
